<template>
  <v-card class="pa-2 pt-0 pb-5">
    <v-container ref="container">
      <v-row
        no-gutters
        align="center"
      >
        <v-col class="headline">
          Add new connection
        </v-col>

        <v-col cols="auto">
          <v-btn
            small
            fab
            icon
            @click="hideModal"
          >
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <ul>
            <li>Add the best contacts you have worked with to the network</li>
            <li>They will enjoy the benefit of being part of the leading open network for top tier digital professionals</li>
            <!-- <li>And you will earn £1000 or €1000 when Riverflex staff them on one of our projects (see T&Cs)</li> -->
          </ul>
        </v-col>
      </v-row>

      <v-row
        v-if="showMoreInfo"
        no-gutters
      >
        <v-col>
          <v-btn
            text
            color="secondary"
            class="underline pa-0"
            @click="handleMoreInfoClick"
          >
            More information
          </v-btn>
        </v-col>
      </v-row>

      <v-row
        class="my-7 text-center"
        no-gutters
      >
        <v-col
          cols="12"
          class="title"
        >
          Share your personal connection link:
        </v-col>
        <v-col
          cols="12"
          class="mt-4"
        >
          <v-btn
            rounded
            color="primary"
            dark
            @click="onCopyBtnClick"
          >
            {{ copyBtnText }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row
        class="text-center"
        no-gutters
      >
        <v-col
          cols="12"
          class="title"
        >
          Email your contacts:
        </v-col>
        <v-col
          cols="12"
          class="mt-4"
        >
          <v-btn
            rounded
            color="primary"
            @click="onEmail"
          >
            Invite via email
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import { IUser } from '@/types/models/user.model'
import { inviteToNewtorkEvents } from '@/segmentAnalytics/connections'

@Component({
  computed: {
    ...mapGetters(['profile', 'profileID'])
  }
})
export default class AddConnection extends Vue {
  @Prop({ default: false }) showMoreInfo: boolean

  // data
  isCopied: boolean = false

  // computed
  profile: IUser
  profileID: number

  get copyBtnText (): string {
    return this.isCopied ? 'Link Copied' : 'Copy Link'
  }

  get connectURL (): string {
    return `${window.location.origin}/connect/${this.profileID}`
  }

  // methods
  hideModal () {
    inviteToNewtorkEvents.trackClose()
    this.$emit('hide')
    this.isCopied = false
  }

  async onCopyBtnClick () {
    await this.$copyText(this.connectURL, this.$refs.container).catch(error => console.warn('Can not copy', error))
    this.isCopied = true
    inviteToNewtorkEvents.trackCopyLink()
    this.$analytics.sendCopyLinkClick()
  }

  onEmail () {
    inviteToNewtorkEvents.trackInviteViaEmail()
    const subject = `Join ${this.profile.name} on the Riverflex Platform`
    const body = `
      Hi,
      I've recently been using the Riverflex platform which is designed for independent consultants to network and find opportunities. I think you would find it useful too.

      It would be great to connect with you there.

      Here is the link to sign up: ${this.connectURL}

      Or if you would like more information, you can visit the Riverflex site www.riverflex.com and find out about the platform.

      Looking forward to connecting!

      ${this.profile.name}
    `
    const mail = `mailto:?subject=${ encodeURIComponent(subject) }&body=${ encodeURIComponent(body) }`
    window.open(mail, '_blank')
    this.$analytics.sendInviteViaEmailClick()
  }

  handleMoreInfoClick () {
    inviteToNewtorkEvents.trackMoreInfoTap()
    this.$emit('moreInfoClick')
  }
}
</script>
<style lang="scss" scoped>
.underline {
  text-decoration: underline
}
</style>
